import React, { useState } from 'react';
import IcePublishedPanel from './IcePublishedPanel';
import IceAdminPanel from './IceAdminPanel';

export default function IceView() {
  const [tab, setTab] = useState('published');

  return (
    <div className="p-4 space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div>
          <div className="text-xs font-semibold text-slate-600">ISO Compliance Engine</div>
          <div className="text-sm text-slate-600">/ice</div>
        </div>

        <div className="inline-flex rounded border border-slate-200 bg-white overflow-hidden">
          <button
            type="button"
            onClick={() => setTab('published')}
            className={`px-3 py-1.5 text-sm font-semibold ${tab === 'published' ? 'bg-slate-900 text-white' : 'bg-white text-slate-800 hover:bg-slate-50'}`}
          >
            Publicerat
          </button>
          <button
            type="button"
            onClick={() => setTab('admin')}
            className={`px-3 py-1.5 text-sm font-semibold ${tab === 'admin' ? 'bg-slate-900 text-white' : 'bg-white text-slate-800 hover:bg-slate-50'}`}
          >
            Admin
          </button>
        </div>
      </div>

      {tab === 'admin' ? <IceAdminPanel /> : <IcePublishedPanel />}
    </div>
  );
}
